//	Remove once all status related components are fully switched to enums
export const STRATEGY_STATUSES = {
  1: 'running_and_active',
  2: 'upcoming',
  3: 'expired',
  4: 'running_and_paused',
};

export const STRATEGY_STATUS_LABELS = {
  1: 'Live',
  2: 'Upcoming',
  3: 'Completed',
  4: 'Paused',
};

export const STRATEGY_LABELS = {
  1: 'Product Launch',
  2: 'Sale',
  3: 'Vendor Funded',
  4: 'Share of Voice',
  5: 'Preferred Publisher',
  6: 'Growth Incentive',
};

export const STRATEGY_BUDGET_TYPE_LABELS = {
  lifetime: 'Lifetime',
  monthly: 'Monthly',
};

export const STRATEGY_VISIBILITY_LABELS = {
  public: 'Public',
  admin: 'Admin',
};

export const STRATEGY_PRICING_MODEL_LABELS = {
  EPP: 'ROI',
  CPC: 'CPC',
};

export const STRATEGY_PAYMENT_MODEL_LABELS = {
  EPP: 'ROI',
  EPC: 'CPC',
  COGS: 'COGS',
};

export const STRATEGY_GROUP_TYPES = {
  1: 'vendor_funded',
  2: 'marketplace',
  3: 'direct_deal',
};

// TODO: Clarify the labels for these
export const STRATEGY_GROUP_TYPE_LABELS = {
  1: 'Vendor Funded',
  2: 'Marketplace',
  3: 'Direct Deal',
};

export const STRATEGY_OBJECTIVES = {
  1: 'Default',
  2: 'Sale',
  3: 'Product Launch',
  4: 'Product Category',
  5: 'Hero Products',
  6: 'Keywords',
};
